import { render } from "./Template4View.vue?vue&type=template&id=1ee8fa2f"
import script from "./Template4View.vue?vue&type=script&lang=js"
export * from "./Template4View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__